export default __webpack_public_path__ + "static/media/IMG_9980.b64df841.jpg";